import Flyout from "./components/flyout/Flyout.svelte"
import { mount } from "svelte"
import { determinePageCluster } from "./tracking/pageCluster"
import { submitEvent } from "@otto-ec/tracking-bct"

function initTracking() {
    const flyoutPopover = document.querySelector(".fti-fly-js-popover")
    if (!flyoutPopover) return

    flyoutPopover.addEventListener("oc-popover-open", () => {
        void submitEvent({
            aftersales_NaviSource: [determinePageCluster() || ""],
            aftersales_NaviType: ["MeinKontoHeader"],
            aftersales_NaviActivity: ["Flyout_open"],
        })
    })

    flyoutPopover.addEventListener("oc-popover-close", () => {
        void submitEvent({
            aftersales_NaviType: ["MeinKontoHeader"],
            aftersales_NaviActivity: ["Flyout_close"],
        })
    })
}

export function logSvelteError(reason: unknown) {
    console.error("[fti_flyout] Svelte hydration failed, activating fallback", reason)
}

function removeJSFallback() {
    const link = document.querySelector<HTMLElement>(".fti-fly-js-my-account-link")
    if (link) {
        link.setAttribute("href", "javascript:void(0)")
    }
}

export function initFlyout() {
    const iconDiv = document.querySelector(".fti-fly-js-my-account-icon")
    const target = iconDiv?.parentElement

    if (!iconDiv || !target) {
        logSvelteError("Missing DOM elements")
        return
    }

    initTracking()

    try {
        mount(Flyout, {
            target,
            anchor: iconDiv.nextSibling ?? undefined,
        })
        removeJSFallback()
    } catch (e) {
        logSvelteError(e)
    }
}

initFlyout()
